import React,{useState,useRef} from 'react'
// import {Link, BrowserRouter, Route, Routes} from "react-router-dom";
// import Ob from './cse4sub/Ob.js'; 
import syllabus from "./assets/csesyllabus.pdf"
import elective from "./assets/ElectivePaper.pdf"
import cs1 from "./assets/ash1.pdf"
import cs2 from "./assets/ash2.pdf"
import cs3 from "./assets/CSE3.pdf"
import cs4 from "./assets/CSE4.pdf"
import cs5 from "./assets/CSE5.pdf"
import cs6 from "./assets/CSE6.pdf"
import cs7 from "./assets/CSE7.pdf"
import Dept from './Dept';

import cseimg from "./cseimg.jpg"
// import AE from './AE';
export default function CSE() {
  
  const [sem, setSem] = useState([{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}
    ,{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}]);

  const ref = useRef(null);

  const handleClick = () => {
    ref.current.scrollIntoView({behavior: 'smooth'});
  };
  
  function contentOfElectivePapers(){
    let paper=[
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub: 'List of Elective Papers:'},{sub:'Artificial Intelligence'},
      {sub:'Neural Networks'},{sub:'Deep Learning'},{sub:'Soft Computing'},
      {sub:'Data Mining & Data Warehousing'},
     {sub: 'Internet of Things(IOT)'}, {sub:'Social Networks Analysis'},
      {sub:'Mobile Computing'},{sub:'Data Analysis'},
      {sub:'Image Processing'},{sub:'Computer Graphics'},
      {sub:'Computational Complexity'},{sub:'Basic Programming Concept'},
      {sub:'Software Engineering'},{sub:'Embeded Computing System'},
      {sub:'Advance Operating System'},{sub:'Network on Chip'},
      {sub:'Information Retrieval'},{sub:'Advance Java Programming'},
      {sub:'Machine Learning'},{sub:'Web & Internet'},{sub:'Matlab'},{sub:'Cloud Computing'},
      {sub:'Quantum Computing'},
      {sub:'Advance Computer Architecture'},{sub:'Computational Geometry'},
      {sub:'Distributed Systems'},{sub:'Formal Methods for System Verifications'},
      {sub:'Cryptography & Network Security'},{sub:'Theory of Computation'},
      {sub:'Operations Research'},{sub:'Advance Algorithms'},
      { sub:"the Elective Papers",link:elective}//42nd
    ];
    setSem(paper);
  }
  function contentOfSem1(){
    let content=[
      {title: "Subjects:",sub:"Engineering Physics(ASH101)", link:"/CSE/Ep"},
      {sub:"Mathematics-1(ASH102)", link:"CSE/M_1"},
      {sub:"Preparatory English(ASH103)", link:"CSE/Peng"},
      {sub:"Engineering Physics Lab(ASH104)", link:"CSE/EpLab"},
      {sub:"Workshop/Manufacturing Practices(ASH105)", link:"CSE/Wpm"},
      {sub:"Engineering Graphics & Design(ASH106)", link:"CSE/Egd"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
       {sub:""},{sub:""},{sub:"1st Semester",link:cs1}//42nd
      
    ];
    setSem(content);
  }
  function contentOfSem2(){
    let content=[
      {title: "Subjects:",sub:"Engineering Chemistry(ASH201)", link:"/CSE/Ec"},
      {sub:"Mathematics-2(ASH202)", link:"CSE/M_2"},
      {sub:"Programming for problem Solving(ASH203)", link:"CSE/Pfps"},
      {sub:"Basic Electrical Engineering(ASH204)", link:"CSE/Bee"},
      {sub:"English-2(ASH205)", link:"CSE/Eng_2"},
      {sub:"Engineering Chemistry Lab(ASH206)", link:"CSE/EcLab"},
      {sub:"Programming for Problem Solving Lab(ASH207)", link:"CSE/CLab"},
      {sub:"Basic Electrical Engineering Lab(ASH208)", link:"CSE/BeeLab"},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"2nd Semester",link:cs2}
    ];
    setSem(content);
  }
  function contentOfSem3(){
    let content=[
      {title: "Subjects:",sub:"Mathematics-3(ASH301C)", link:"/CSE/M_3"},
      {sub:"Effective Technical Communication(ASH302)", link:"CSE/Etc"},
      {sub:"Analog Electronic Circuit(CSE301)", link:"CSE/Aec"},
      {sub:"Data Structure(CSE302)", link:"CSE/Ds"},
      {sub:"Digital Electronics(CSE303)", link:"CSE/De"},
      {sub:"Microprocessor(CSE304)", link:"CSE/Mp"},
      {sub:"Analog Electronic Circuit Lab(CSE305)", link:"CSE/AecLab"},
      {sub:"Data Structure Lab(CSE306)", link:"CSE/DsLab"},
      {sub:"Digital Electronics Lab(CSE307)", link:"CSE/DeLab"},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"3rd Semester",link:cs3}
    ];
    setSem(content);
  }
  function contentOfSem4(){
    let content=[
       {title: "Subjects:", sub: "Organizational Behavior(ASH401)",link: "/CSE/Ob"},
       {sub:"Environmental Science(ASH402)", link:" CSE/Evs" },
        {sub: "Discrete Mathematics(CSE401)", link:"CSE/Dm"},
        {sub:"Computer Organization & Architecture(CSE402)", link:"CSE/Coa"},
        {sub:"Database Mangement System(CSE403)", link:"/CSE/Dbms"},
        {sub:"Object Oriented Programming(CSE404)",link:"CSE/Oops"},
        {sub:"Computer Architecture & Microprocessor Lab(CSE405)", link:"/CSE/ComLab"},
        {sub:"Database Management System Lab(CSE406)", link:"/CSE/DbmsLab"},
        {sub:"Object Oriented Programming Lab(CSE407)", link:"/CSE/OopsLab"},
        {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"4th Semester",link:cs4}
    ];
       setSem(content);
  }
  function contentOfSem5(){
    let content=[
      {title: "Subjects:",sub:"Mathematics_4(ASH501)", link:"/CSE/M_4"},
      {sub:"Constitution of India(ASH503)", link:"CSE/Coi"},
      {sub:"(Python)IT Workshop(CSE501)", link:"CSE/Py"},
      {sub:"Design & Analysis Algorithms(CSE502)", link:"CSE/Daa"},
      {sub:"Operating System(CSE503)", link:"CSE/Os"},
      {sub:"Formal Language & Automata Theory(CSE504)", link:"CSE/Fl"},
      {sub:"Design & Analysis Algorithms Lab(CSE506)", link:"CSE/DaaLab"},
      {sub:"Operating System Lab(CSE507)", link:"CSE/OsLab"},
      {sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"5th Semester",link:cs5}
    ];
    setSem(content);
  }
  function contentOfSem6(){
    let content=[
      {title: "Subjects:",sub:"Compiler Design(CSE601)", link:"/CSE/Cd"},
      {sub:"Computer Networks(CSE602)", link:"CSE/Cn"},
      {sub:"Software Engineering(CSE604)", link:"CSE/Se"},
      {sub:"Compiler Design Lab(CSE605)", link:"CSE/CdLab"},
      {sub:"Computer Network Lab(CSE606)", link:"CSE/CnLab"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"6th Semester",link:cs6}
    ];
    setSem(content);
  }
  function contentOfSem7(){
    let content=[
      {title: "Subjects:",sub:"(Effective Technical Communication) Humanities-2(CSE702)", link:"/CSE/Etch_2"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:"7th Semester",link:cs7}
    ];
    setSem(content);
  }
    return (
      <>
      <Dept title="Dept. of Computer Science & Engineering" dept="CSE" syllabus={syllabus} img={cseimg}/>
      <div className='container my-3'>
            <h5 className='text-center'>Select your semester to see corresponding content:</h5>
             <div className=" btn-toolbar justify-content-center" role="toolbar" aria-label="Toolbar with button groups">
                <div className="btn-group btn-group-sm" role="group" aria-label="Small group">
               
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem1();handleClick();}}>1st sem</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem2();handleClick();}}>2nd</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem3();handleClick();}}>3rd</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem4();handleClick();}}>4th</button>
                
                  <button type="button" className="btn btn-secondary"onClick={()=>{contentOfSem5();handleClick();}}>5th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem6();handleClick();}}>6th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem7();handleClick();}}>7th</button>
                  <button type="button" className="btn btn-secondary" onClick={() => alert("There is no any subject in 8th sem!")} >8th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfElectivePapers();handleClick();}}>Elective Papers</button>
                </div>
             </div>
      </div>
         <div className='container my-4 '>
         <div className='container my-4 text-center'  >
            
            <div className="col d-flex justify-content-center my-4">
              <div className="card my-3"  style= {{width: "20rem"}}>
                  
                  <div className="card-body">
                      <h5 className="card-title">Course Structure/Syllabus of <b>{sem[42].sub}</b> </h5>
                      <a href={sem[42].link} className="btn btn-primary" target="blank">Preview/Download</a>
                  </div>
              </div>
            </div>
        </div>
         <h2 className='mx-5'>{sem[0].title}</h2>       
           <h5 className='mx-5' ref={ref}>
            <div className='my-2'> <a href={sem[0].link}>{sem[0].sub}</a></div>
            <div className='my-2'> <a href={sem[1].link}>{sem[1].sub}</a></div>
            <div className='my-2'><a href={sem[2].link}>{sem[2].sub}</a></div>
            <div className='my-2'><a href={sem[3].link}>{sem[3].sub}</a></div>
            <div className='my-2'><a href={sem[4].link}>{sem[4].sub}</a></div> 
            <div className='my-2'><a href={sem[5].link}>{sem[5].sub}</a></div>
            <div className='my-2'><a href={sem[6].link}>{sem[6].sub}</a></div>
            <div className='my-2'><a href={sem[7].link}>{sem[7].sub}</a></div>
            <div className='my-2'> <a href={sem[8].link}>{sem[8].sub}</a></div>
           </h5>
           <h3 className='mx-5'>{sem[9].sub}</h3>
           <h5  className='mx-5' ref={ref}>
             <div>{sem[10].sub}</div> <div>{sem[11].sub}</div> <div>{sem[12].sub}</div>
            <div>{sem[13].sub}</div> <div>{sem[14].sub}</div> <div>{sem[15].sub}</div> <div>{sem[16].sub}</div>
            <div>{sem[17].sub}</div> <div>{sem[18].sub}</div> <div>{sem[19].sub}</div> <div>{sem[20].sub}</div>
            <div>{sem[21].sub}</div> <div>{sem[22].sub}</div> <div>{sem[23].sub}</div> <div>{sem[24].sub}</div>
            <div>{sem[25].sub}</div> <div>{sem[26].sub}</div> <div>{sem[27].sub}</div> <div>{sem[28].sub}</div>
            <div>{sem[29].sub}</div> <div>{sem[30].sub}</div> <div>{sem[31].sub}</div> <div>{sem[32].sub}</div>
            <div>{sem[33].sub}</div> <div>{sem[34].sub}</div> <div>{sem[35].sub}</div> <div>{sem[36].sub}</div>
            <div>{sem[37].sub}</div> <div>{sem[38].sub}</div> <div>{sem[39].sub}</div> <div>{sem[40].sub}</div>
            <div>{sem[41].sub}</div> 
           </h5>
          {/* <h4 className='mx-5'><a href={sem[42].link}>{sem[42].sub}</a> </h4> */}
         </div>
      
    </>
  );
}
